export default __webpack_public_path__ + "static/media/spotify-logo-white.f48fb565.png";